import { useGetPaymentProcessor } from '@pflegenavi/frontend/api-nursing-home';
import { useFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import { FeatureFlag } from '@pflegenavi/shared/api';

export const useReportingV3Visible = (): boolean => {
  const paymentProcessor = useGetPaymentProcessor();
  const reportingV3Enabled = useFeatureFlagEnabled(FeatureFlag.dev_ReportingV3);
  return paymentProcessor !== 'stripe' && reportingV3Enabled;
};
